import { DataModel } from "common/models/utility-models/base-model";

export class TravelReimbursementModel extends DataModel {
    travelTitleOrRemark: string = '';
    travelStartDate: any = '';
    travelEndDate: any = '';
    travelDoc: any = '';
    assignment_student_id: any = '';
    travelEmailDoc: string = '';
    signed_url_travelEmailDoc: string = '';
}
